import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import FaleConosco from "./sections/FaleConosco";
import ServiceAreas from "./sections/ServiceAreas";
import CoastalFootnotes from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <FaleConosco />
      <ServiceAreas />
      <CoastalFootnotes />
    </div>;
}